export const fr = {
  languageSwitcher: {
    ariaLabel: "Choisir la langue de l'interface",
    enShort: 'EN',
    enTitle: 'Anglais',
    frShort: 'FR',
    frTitle: 'Français',
  },
  publicNav: {
    signIn: 'Connexion',
    back: 'Retour',
  },
  auth: {
    brandTagline: 'Classement de CV',
    common: {
      email: 'Adresse e-mail',
      emailPlaceholder: 'vous@entreprise.fr',
      password: 'Mot de passe',
      showPassword: 'Afficher le mot de passe',
      hidePassword: 'Masquer le mot de passe',
      sending: 'Envoi en cours...',
      signIn: 'Se connecter',
    },
    errors: {
      requiredEmail: 'Saisissez votre adresse e-mail.',
      requiredEmailPassword: 'Saisissez votre adresse e-mail et votre mot de passe.',
      requiredFields: 'Renseignez tous les champs.',
      requiredName: 'Saisissez votre nom.',
      passwordMinimum: 'Le mot de passe doit contenir au moins 8 caractères.',
      passwordMismatch: 'Les mots de passe ne correspondent pas.',
      accountLookupSafe: 'Si un compte existe pour cette adresse e-mail, un code de réinitialisation sera envoyé.',
      incorrectCredentials: 'Adresse e-mail ou mot de passe incorrect.',
      unconfirmed: 'Votre compte n’est pas encore vérifié. Saisissez le code reçu par e-mail pour continuer.',
      usernameExists: 'Un compte existe déjà avec cette adresse e-mail.',
      invalidPassword: 'Le mot de passe doit contenir au moins 8 caractères, avec une majuscule, une minuscule et un chiffre.',
      invalidCode: 'Le code de vérification est incorrect. Réessayez.',
      expiredCode: 'Le code de vérification a expiré. Demandez-en un nouveau.',
      tooManyAttempts: 'Trop de tentatives. Patientez quelques instants avant de réessayer.',
      generic: 'Une erreur est survenue. Réessayez.',
    },
    signIn: {
      verifiedNotice: 'Votre adresse e-mail est vérifiée. Connectez-vous pour continuer.',
      welcome: 'Bon retour',
      subtitle: 'Connectez-vous à votre compte WorkflowPro',
      verifyAccount: 'Vérifier le compte',
      resendCode: 'Renvoyer le code',
      passwordPlaceholder: 'Saisissez votre mot de passe',
      forgotPassword: 'Mot de passe oublié ?',
      noAccount: 'Vous n’avez pas de compte ?',
      createFree: 'Créer un compte gratuitement',
      legalPrefix: 'En vous connectant, vous acceptez nos',
      terms: 'Conditions d’utilisation',
      and: 'et notre',
      privacy: 'Politique de confidentialité',
    },
    signUp: {
      title: 'Créez votre compte',
      subtitle: 'Commencez gratuitement à classer vos CV avec WorkflowPro',
      name: 'Votre nom',
      namePlaceholder: 'Camille Martin',
      company: 'Nom de l’entreprise',
      companyPlaceholder: 'Cabinet Martin',
      workEmail: 'E-mail professionnel',
      createPassword: 'Créez un mot de passe robuste',
      confirmPassword: 'Confirmez le mot de passe',
      repeatPassword: 'Répétez votre mot de passe',
      createAccount: 'Créer un compte gratuitement',
      legalPrefix: 'En créant un compte, vous acceptez nos',
      alreadyAccount: 'Vous avez déjà un compte ?',
      verifyAndStart: 'Vérifier et commencer',
      strength: {
        minimum: 'Au moins 8 caractères',
        uppercase: 'Une majuscule',
        lowercase: 'Une minuscule',
        number: 'Un chiffre',
        weak: 'Faible',
        fair: 'Moyen',
        good: 'Bon',
        strong: 'Fort',
      },
    },
    verification: {
      title: 'Consultez votre messagerie',
      instructions: 'Saisissez le code de vérification à 6 chiffres envoyé à',
      emailFallback: 'votre adresse e-mail',
      code: 'Code de vérification',
      verifyEmail: 'Vérifier l’adresse e-mail',
      newCodeSent: 'Un nouveau code de vérification a été envoyé. Consultez votre messagerie.',
      sendNewCode: 'Envoyer un nouveau code',
      noCode: 'Vous n’avez pas reçu le code ?',
      resendCode: 'Renvoyer le code',
      successTitle: 'Adresse e-mail vérifiée',
      successBody: 'Votre adresse e-mail est vérifiée. Connectez-vous pour continuer sur WorkflowPro.',
    },
    forgotPassword: {
      back: 'Retour à la connexion',
      title: 'Réinitialisez votre mot de passe',
      requestInstructions: 'Saisissez votre adresse e-mail. Si un compte existe, un code de réinitialisation sera envoyé.',
      sendCode: 'Envoyer le code de réinitialisation',
      genericNotice: 'Si un compte existe pour cette adresse e-mail, un code de réinitialisation sera envoyé.',
      enterCode: 'Saisissez le code de réinitialisation',
      codeInstructions: 'Utilisez le code reçu par e-mail, si un compte correspond à cette adresse.',
      resetCode: 'Code de réinitialisation',
      newPassword: 'Nouveau mot de passe',
      newPasswordPlaceholder: 'Nouveau mot de passe',
      resetAction: 'Réinitialiser le mot de passe',
      doneTitle: 'Mot de passe réinitialisé',
      doneBody: 'Votre mot de passe a bien été réinitialisé.',
      signInNewPassword: 'Se connecter avec le nouveau mot de passe',
    },
  },
  landing: {
    preview: {
      topCandidates: '2 candidats à examiner en priorité',
      jobTitle: 'Ingénieur logiciel senior',
      rankedCount: '4 candidats classés',
      topMatch: 'Meilleur score : 94 %',
      years: '{count} ans',
      whyExample: 'Correspond à 8 compétences requises sur 10 - forte expérience AWS',
      scoreBands: {
        excellent: 'Excellent',
        good: 'Bon',
        partial: 'Partiel',
        poor: 'Faible',
      },
      reviewBadge: 'À examiner',
      whyPrefix: 'Correspondance',
      bottomNote: 'Aperçu du classement des candidats - Aide à la décision du recruteur',
      export: 'Exporter la présélection',
    },
    faq: [
      {
        q: 'Faut-il créer un compte ?',
        a: "Non. Vous pouvez essayer WorkflowPro gratuitement sans créer de compte. Créez un compte lorsque vous souhaitez enregistrer et gérer vos projets de recrutement.",
      },
      {
        q: 'Comment WorkflowPro classe-t-il les candidats ?',
        a: 'WorkflowPro compare chaque CV aux exigences du poste et fournit un classement assisté par IA avec une décomposition du score et des éléments d’appui.',
      },
      {
        q: 'Quels formats de fichiers sont acceptés ?',
        a: 'Vous pouvez importer des CV au format PDF et DOCX.',
      },
      {
        q: 'Mes données sont-elles protégées ?',
        a: 'Les documents importés sont traités conformément à notre politique de confidentialité.',
      },
      {
        q: 'Puis-je comparer des candidats ?',
        a: 'Oui. La comparaison de candidats est disponible avec les offres Pro et Business.',
      },
      {
        q: 'Puis-je commencer gratuitement ?',
        a: 'Oui. L’offre Free permet d’essayer WorkflowPro sur un besoin de recrutement réel avant de passer à une offre payante.',
      },
    ],
    plans: {
      free: {
        name: 'Free',
        price: '0 \u20ac',
        audience: 'Pour essayer WorkflowPro sur un besoin de recrutement réel.',
        cta: 'Commencer gratuitement',
        features: [
          '1 poste actif',
          'Jusqu’à 5 CV',
          'Classement des candidats assisté par IA',
          'Décomposition simple du score',
        ],
      },
      starter: {
        name: 'Starter',
        price: '39 \u20ac/mois',
        audience: 'Pour les recruteurs indépendants et les petits cabinets de recrutement.',
        cta: 'Choisir Starter',
        features: [
          'Jusqu’à 5 postes actifs',
          'Jusqu’à 400 CV par mois',
          'Inclut toutes les fonctionnalités Free',
          'Extraction des compétences et éléments d’appui',
          'Export des résultats',
        ],
      },
      pro: {
        name: 'Pro',
        price: '69 \u20ac/mois',
        audience: 'Pour les recruteurs qui gèrent davantage de volume.',
        cta: 'Choisir Pro',
        features: [
          'Jusqu’à 20 postes actifs',
          'Jusqu’à 2 000 CV par mois',
          'Inclut toutes les fonctionnalités Starter',
          'Comparaison de candidats',
        ],
      },
      business: {
        name: 'Business',
        price: '129 \u20ac/mois',
        audience: 'Pour les petits cabinets de recrutement avec des volumes de CV plus élevés.',
        cta: 'Choisir Business',
        features: [
          'Jusqu’à 100 postes actifs',
          'Jusqu’à 10 000 CV par mois',
          'Inclut toutes les fonctionnalités Pro',
        ],
      },
    },
    navCta: 'Obtenir une présélection',
    eyebrow: 'Présélections de candidats classées par IA',
    headline1: 'Identifiez les candidats',
    headline2: 'à examiner',
    headline3: 'en priorité.',
    subheading: 'Donnez à WorkflowPro une description de poste et les CV de vos candidats. L’outil vous aide à identifier les candidats à examiner en priorité. Aucune inscription requise pour votre première présélection.',
    primaryCta: 'Importer des CV et obtenir une présélection',
    pricingCta: 'Voir les tarifs',
    trustPrivacy: 'Informations de confidentialité disponibles',
    trustRanking: 'Aide au classement pour la présélection',
    trustFree: 'Première présélection gratuite',
    trustSetup: 'Aucune configuration requise',
    proofReview: 'Présélection à examiner',
    proofReviewLabel: 'avec classement assisté par IA',
    proofReduce: 'Réduire le tri manuel',
    proofReduceLabel: 'avec une comparaison structurée des candidats',
    proofFree: 'Essai gratuit',
    proofFreeLabel: '5 CV, sans carte bancaire',
    proofEu: 'Hébergement UE',
    proofEuLabel: 'voir la politique de confidentialité',
    howTitle: 'Des CV à la présélection en trois étapes',
    howIntro: 'Décrivez le poste à pourvoir, importez les CV des candidats et laissez WorkflowPro les classer par correspondance afin de concentrer votre analyse sur les CV les plus alignés avec les exigences du poste.',
    step1Title: 'Décrivez le poste et importez les CV',
    step1Description: 'Saisissez l’intitulé et la description du poste, puis importez les CV de vos candidats.',
    step2Title: 'WorkflowPro classe chaque candidat',
    step2Description: 'Chaque CV est comparé aux exigences du poste et classé selon sa correspondance globale.',
    step3Title: 'Examinez votre présélection',
    step3Description: 'Consultez les candidats classés, comparez leurs points forts et décidez quels candidats examiner en priorité.',
    benefitsTitle: 'Examinez les candidats avec davantage de contexte.',
    benefitsIntro: 'WorkflowPro aide les recruteurs indépendants et les petits cabinets à identifier les candidats à examiner en priorité, sans changer leur façon de recruter.',
    benefit1Title: 'Prioriser l’analyse des CV',
    benefit1Description: 'Consultez des candidats classés au lieu de lire chaque CV de bout en bout dès le départ.',
    benefit2Title: 'Vous concentrer sur les candidats mieux classés',
    benefit2Description: 'Faites remonter les candidats avec les scores de correspondance les plus élevés afin de commencer par les CV les plus alignés avec le poste.',
    benefit3Title: 'Appliquer un processus d’analyse cohérent',
    benefit3Description: 'Évaluez chaque candidat par rapport aux mêmes exigences de poste, avec un processus homogène.',
    benefit4Title: 'Commencer avec une description de poste',
    benefit4Description: 'Saisissez le contexte du poste, importez les CV et consultez les résultats classés dans un même flux.',
    pricingTitle: 'Des tarifs simples et transparents',
    pricingIntro: 'Commencez gratuitement, puis changez d’offre lorsque vos besoins de recrutement augmentent. Pas de frais cachés, pas d’engagement long terme.',
    popular: 'Le plus choisi',
    faqTitle: 'Questions fréquentes',
    finalTitle: 'Prêt à prioriser votre analyse des candidats ?',
    finalDescription: 'Utilisez WorkflowPro pour comparer les CV des candidats à la description du poste et concentrer votre analyse sur les candidats à examiner en priorité. Votre première présélection est gratuite.',
    finalStart: 'Commencer gratuitement',
    noCard: 'Aucune carte bancaire requise.',
    contact: 'Contact',
    pricing: 'Tarifs',
    privacy: 'Politique de confidentialité',
    terms: 'Conditions d’utilisation',
    cookies: 'Politique relative aux cookies',
    copyright: '© 2026 WorkflowPro. Tous droits réservés.',
  },
  anonUpload: {
    toasts: {
      invalidFiles: 'Seuls les fichiers PDF et DOCX sont acceptés',
      maxReady: '{count} CV prêts à importer',
      addCv: 'Ajoutez au moins un CV',
      genericError: 'Une erreur est survenue',
    },
    heading: 'Importer des CV pour un classement assisté par IA',
    subheading: 'Aucun compte nécessaire. Importez jusqu’à 5 CV et consultez les résultats classés une fois l’analyse terminée.',
    existingTitle: 'Continuer votre présélection en cours',
    existingDescription: 'Vos résultats anonymes sont encore enregistrés dans ce navigateur.',
    startOver: 'Recommencer',
    continue: 'Continuer',
    jobDetails: 'Informations sur le poste',
    optionalContext: '(contexte optionnel pour le classement)',
    jobTitle: 'Intitulé du poste',
    jobTitlePlaceholder: 'ex. Ingénieur logiciel senior',
    jobDescription: 'Description du poste',
    jobDescriptionPlaceholder: 'Collez ici la description du poste pour donner du contexte au classement...',
    uploadCvs: 'Importer des CV',
    added: '({count}/{max} ajoutés)',
    maxReached: 'Maximum de {count} CV atteint',
    dropHere: 'Déposez les CV ici...',
    dragHere: 'Glissez-déposez les CV ici',
    browse: 'ou cliquez pour parcourir - PDF et DOCX - {count} fichiers max.',
    rankCvs: 'Classer {count} CV avec l’IA',
    rankNoCount: 'Classer les CV avec l’IA',
    freeNote: 'Gratuit - Aucune inscription requise - Résultats une fois l’analyse terminée',
    processingTitle: 'Analyse des CV en cours',
    processingFile: 'Analyse de : {file}',
    almostDone: 'Analyse presque terminée...',
    processingSteps: [
      'Extraction du texte des CV...',
      'Identification des compétences et de l’expérience...',
      'Correspondance avec les exigences du poste...',
      'Calcul des scores de correspondance...',
    ],
    doneTitle: 'Vos CV sont classés !',
    processedSuccessfully: '{count} CV traités avec succès',
    score: 'Score : {score}',
    seeRankings: 'Voir le classement complet',
    saveNote: 'Créez un compte gratuitement pour enregistrer les résultats et traiter plus de CV',
  },
  anonResults: {
    confidence: {
      veryHigh: 'Très forte correspondance',
      high: 'Forte correspondance',
      moderate: 'Correspondance modérée',
      low: 'Faible correspondance',
    },
    oneWorthReviewing: '1 candidat à examiner en priorité',
    manyWorthReviewing: '{count} candidats à examiner en priorité',
    basedOnRequirements: 'selon les exigences du poste',
    highestScore: 'Score de correspondance le plus élevé',
    reviewFirst: 'À examiner en priorité',
    candidateFallback: 'Candidat {number}',
    matchedSkills: 'Compétences correspondantes :',
    more: '+{count} autres',
    higherScore: 'Score de correspondance élevé',
    gapsDetected: 'Points à examiner détectés - à vérifier attentivement',
    match: '{score} % de correspondance',
    experience: 'Expérience',
    years: '{count} ans',
    education: 'Formation',
    matchedSkillsHeading: 'COMPÉTENCES CORRESPONDANTES',
    missingSkillsHeading: 'COMPÉTENCES MANQUANTES',
    saveFound: 'Vous avez trouvé {count} candidat{plural} classé{plural} à examiner. Enregistrez-les.',
    saveExpired: 'Enregistrez vos résultats avant leur expiration',
    nameJoiner: ' et ',
    createAccountFound: 'Créez un compte gratuit pour enregistrer {names}, importer plus de CV, présélectionner des candidats et exporter vos résultats.',
    createAccountExpired: 'Créez un compte gratuit pour enregistrer ce classement, importer plus de CV et exporter votre présélection.',
    freeAccountTitle: 'AVEC UN COMPTE GRATUIT, VOUS POUVEZ',
    accountBenefits: [
      'Enregistrer les résultats dans votre compte',
      'Présélectionner et examiner les candidats',
      'Importer plus de CV',
      'Exporter la liste classée en CSV',
      'Créer plusieurs postes',
    ],
    saveContinue: 'Enregistrer les résultats et continuer gratuitement',
    newUpload: 'Nouvel import',
    noCard: 'Aucune carte bancaire - Créez un compte pour enregistrer ces résultats',
    expiredMessage: 'Votre présélection anonyme a expiré. Lancez un nouvel import pour classer les candidats.',
    loadError: 'Impossible de charger votre présélection anonyme. Veuillez réessayer.',
    loading: 'Chargement des résultats...',
    startNewUpload: 'Lancer un nouvel import',
    tryAgain: 'Réessayer',
    noCandidates: 'Aucun candidat n’a pu être analysé à partir de votre import.',
    tryAnother: 'Essayer un autre import',
    saveResultsFree: 'Enregistrer gratuitement',
    candidatesRanked: '{count} candidats classés',
    resultsFor: 'Résultats pour : {jobTitle}',
    rankedCandidates: 'Vos candidats classés',
    rankedByScore: 'Classement par score de correspondance IA - Score le plus élevé en premier',
  },
  common: {
    loading: 'Chargement...',
    cancel: 'Annuler',
    save: 'Enregistrer',
    back: 'Retour',
    upgrade: 'Changer d’offre',
    upgradePlan: 'Changer d’offre',
  },
  authenticated: {
    app: {
      pages: {
        jobs: {
          title: 'Postes',
          subtitle: 'Gérez vos postes de recrutement actifs',
        },
        settings: {
          title: 'Paramètres',
          subtitle: 'Gérez votre compte et votre facturation',
        },
        admin: {
          title: 'Administration',
          subtitle: 'Gérez les utilisateurs',
        },
        help: {
          title: 'Fonctionnement',
          subtitle: 'Comprendre le tri de CV assisté par IA',
        },
        billingSuccess: {
          title: 'Changement d’offre confirmé',
          subtitle: 'Votre mise à jour de facturation est disponible dans l’application',
        },
        fallback: {
          title: 'WorkflowPro',
          subtitle: '',
        },
      },
      topBar: {
        jobUsage: 'Vous utilisez {percent} % de vos postes disponibles.',
        cvUsage: 'Vous avez utilisé {percent} % de vos CV mensuels.',
        upgradeMore: 'Changez d’offre pour augmenter vos limites.',
        upgradeNow: 'Changer d’offre',
        closeBanner: 'Fermer le bandeau',
      },
      sidebar: {
        productSubtitle: 'Tri de CV',
        jobs: 'Postes',
        settings: 'Paramètres',
        adminPanel: 'Administration',
        admin: 'Admin',
        help: 'Aide',
        howItWorks: 'Fonctionnement',
        upgrade: 'Changer d’offre',
        overLimit: 'Limite dépassée',
        platformAdmin: 'Administration plateforme',
        adminAccess: 'L’accès administrateur plateforme est sans restriction. Les limites d’usage ne s’appliquent pas.',
        usage: 'Utilisation',
        activeJobs: 'Postes actifs',
        cvsThisMonth: 'CV ce mois-ci',
        upgradePlan: 'Changer d’offre',
        logOut: 'Se déconnecter',
      },
    },
    badges: {
      status: {
        active: 'Actif',
        archived: 'Archivé',
        closed: 'Fermé',
        pending: 'En attente',
        shortlisted: 'Présélectionné',
        rejected: 'Écarté',
        processing: 'En cours',
      },
      role: {
        owner: 'Propriétaire',
        admin: 'Administrateur',
        member: 'Membre',
      },
      score: {
        excellent: 'Excellent',
        good: 'Bon',
        partial: 'Partiel',
        poor: 'Faible',
      },
    },
    recommendations: {
      strong: 'À examiner en priorité',
      good: 'Candidat à examiner',
      partial: 'À examiner attentivement',
      weak: 'Écarts importants',
    },
    dashboard: {
      toasts: {
        deleteForbidden: 'Seuls les propriétaires et administrateurs peuvent supprimer des postes',
        archiveForbidden: 'Seuls les propriétaires et administrateurs peuvent archiver des postes',
        createForbidden: 'Seuls les propriétaires et administrateurs peuvent créer des postes',
        deleted: 'Poste supprimé',
        deleteFailed: 'Impossible de supprimer le poste',
        archived: 'Poste archivé',
        archiveFailed: 'Impossible d’archiver le poste',
      },
      jobLimit: 'Vous avez atteint la limite de postes de l’offre {plan}. Changez d’offre pour créer plus de postes.',
      cvLimit: 'Vous avez utilisé tous vos CV du mois. Changez d’offre pour en traiter davantage.',
      activeJobs: 'Postes actifs',
      cvsThisMonth: 'CV ce mois-ci',
      ofMax: 'sur {max}',
      jobOpenings: 'Postes',
      filters: {
        active: 'Actifs',
        archived: 'Archivés',
        closed: 'Fermés',
      },
      newJob: 'Nouveau poste',
      emptyActive: 'Aucun poste actif pour le moment',
      emptyStatus: 'Aucun poste {status}',
      emptyActiveOwner: 'Créez votre premier poste pour commencer à examiner des CV avec l’aide de l’IA',
      emptyActiveMember: 'Un propriétaire ou administrateur peut créer le premier poste de ce compte.',
      emptyStatusDescription: 'Vous n’avez aucun poste {status}',
      createFirstJob: 'Créer un premier poste',
      candidates: '{count} candidat{plural}',
      topMatch: 'Meilleur score : {score} %',
      archive: 'Archiver',
      deleteTrigger: 'Changez d’offre pour créer plus de postes',
      deleteTitle: 'Supprimer ce poste ?',
      deleteMessage: 'Voulez-vous vraiment supprimer « {title} » ? Cette action retire définitivement tous les candidats associés et ne peut pas être annulée.',
      delete: 'Supprimer',
    },
    newJob: {
      toasts: {
        createForbidden: 'Seuls les propriétaires et administrateurs peuvent créer des postes',
        created: 'Poste créé',
        failed: 'Impossible de créer le poste',
      },
      errors: {
        titleRequired: 'L’intitulé du poste est requis',
        descriptionRequired: 'La description du poste est requise',
        descriptionDetail: 'Ajoutez une description plus détaillée pour que WorkflowPro compare les CV au contexte du poste',
      },
      backToJobs: 'Retour aux postes',
      title: 'Créer un poste',
      subtitle: 'Une description détaillée donne à WorkflowPro un contexte plus clair pour examiner les candidats',
      details: 'Informations sur le poste',
      jobTitle: 'Intitulé du poste',
      jobTitlePlaceholder: 'ex. Ingénieur logiciel senior',
      location: 'Lieu',
      locationPlaceholder: 'ex. Paris, France',
      employmentType: 'Type de contrat',
      employmentTypes: {
        fullTime: 'CDI / temps plein',
        partTime: 'Temps partiel',
        contract: 'Contrat',
        freelance: 'Freelance',
        internship: 'Stage',
      },
      jobDescription: 'Description du poste',
      descriptionPlaceholder: 'Collez ici la description complète du poste. Incluez les responsabilités, le contexte d’équipe et les critères de réussite du rôle...',
      characters: '{count} caractères',
      requirements: 'Exigences et compétences',
      keyRequirements: 'Exigences clés',
      optionalContext: '(contexte optionnel pour l’analyse des candidats)',
      requirementsPlaceholder: 'Listez les compétences, qualifications et exigences spécifiques :\n- 5+ ans d’expérience Python\n- Certification AWS\n- Expérience d’encadrement\n- Anglais courant',
      submit: 'Créer le poste et commencer le tri',
      tipsTitle: 'Conseils pour un classement plus clair',
      tips: {
        detailedDescription: 'Fournir une description de poste détaillée',
        mustHave: 'Inclure les exigences indispensables',
        seniority: 'Décrire le niveau de séniorité et le périmètre',
        tools: 'Lister les outils et plateformes importants',
        responsibilities: 'Inclure les responsabilités et les résultats attendus',
        consistentContext: 'Un contexte de poste clair aide WorkflowPro à comparer les CV aux mêmes exigences',
      },
      scoringTitle: 'Fonctionnement du score candidat',
      scoringItems: {
        domain: 'Adéquation au domaine du poste',
        mustHave: 'Exigences indispensables',
        seniority: 'Adéquation séniorité / expérience',
        responsibility: 'Responsabilités et périmètre',
        tools: 'Outils / plateformes',
        reviewPoints: 'Points à examiner',
        explanation: 'Explication orientée recruteur',
      },
    },
    jobDetailsPanel: {
      title: 'Détails du poste',
      hide: 'Masquer le brief et les exigences du poste',
      show: 'Afficher l’intitulé, la description et les exigences',
      untitled: 'Poste sans intitulé',
      lastUpdated: 'Dernière mise à jour {date}',
      description: 'Description',
      noDescription: 'Aucune description fournie.',
      requirements: 'Exigences',
      editRequirements: 'Modifier les exigences',
      placeholder: 'Listez les compétences indispensables, la séniorité, les outils et le périmètre du poste...',
      noRequirements: 'Aucune exigence fournie pour le moment.',
      noAutoRescore: 'Modifier les exigences ne recalcule pas automatiquement les scores des candidats.',
      updateFailed: 'Impossible de mettre à jour les exigences',
      tip: 'Conseil',
      tipCopy: 'Des exigences claires améliorent le classement, tout en tenant compte des formulations équivalentes.',
      control: 'Contrôle',
      controlCopy: 'Si les exigences changent, vous choisissez de recalculer ou non les scores des candidats existants.',
      rescoreTitle: 'Recalculer les scores des candidats existants ?',
      rescoreDescription: 'Les exigences ont changé. Vous pouvez enregistrer les nouvelles exigences et recalculer les scores des candidats existants, ou enregistrer les exigences sans modifier les scores actuels.',
      saveOnly: 'Enregistrer uniquement',
      saveAndRescore: 'Enregistrer et recalculer',
      saveRequirements: 'Enregistrer les exigences',
    },
    jobDetail: {
      toasts: {
        loadCandidateFailed: 'Impossible de charger le détail du candidat',
        uploadFailed: 'Import échoué',
        processed: '{count} CV traité{plural} avec succès',
        candidateStatus: 'Statut candidat : {status}',
        updateStatusFailed: 'Impossible de mettre à jour le statut',
        exportAll: '{count} candidats exportés',
        exportShortlisted: '{count} candidats présélectionnés exportés',
        exportSelected: '{count} candidats sélectionnés exportés',
        exportFailed: 'Export échoué',
        requirementsSavedRescore: 'Exigences enregistrées et scores recalculés',
        requirementsSaved: 'Exigences enregistrées',
        rescoreWarning: 'Recalcul terminé avec avertissements',
        requirementsFailed: 'Impossible de mettre à jour les exigences',
        compareLimit: 'Vous pouvez comparer jusqu’à 4 candidats',
        compareMinimum: 'Sélectionnez au moins deux candidats à comparer',
      },
      backToJobs: 'Retour aux postes',
      loadingJob: 'Chargement...',
      candidatesCount: '{count} candidat{plural}',
      topScore: 'Meilleur score : {score}',
      refresh: 'Actualiser',
      export: 'Exporter',
      uploadCvs: 'Importer des CV',
      scoreBands: {
        excellent: 'Excellent',
        good: 'Bon',
        partial: 'Partiel',
        poor: 'Faible',
      },
      exportTitle: 'Exporter des candidats',
      exportSubtitle: 'Choisissez les candidats à inclure dans l’export CSV.',
      exportDescription: 'Exporter les candidats sélectionnés ou présélectionnés garde le CSV ciblé. Choisissez tout exporter uniquement si vous avez besoin de la liste complète du poste.',
      exportSelected: 'Exporter la sélection ({count})',
      exportShortlisted: 'Exporter les présélectionnés ({count})',
      exportAll: 'Tout exporter ({count})',
      compareSelected: '{count} candidats sélectionnés pour comparaison',
      compareNow: 'Comparer',
      clear: 'Effacer',
      filters: {
        all: 'Tous',
        shortlisted: 'Présélectionnés',
        pending: 'En attente',
        rejected: 'Écartés',
      },
      candidateTotal: '{count} candidat{plural}',
      loadingCandidates: 'Chargement des candidats...',
      noCandidates: 'Aucun candidat pour le moment',
      noCandidatesDescription: 'Importez des CV pour commencer à classer les candidats pour ce poste',
      table: {
        candidate: 'Candidat',
        score: 'Score',
        experience: 'Expérience',
        skills: 'Compétences',
        actions: 'Actions',
      },
      unknownCandidate: 'Inconnu',
      shortlisted: 'Présélectionné',
      yearsShort: '{count} an{plural}',
      view: 'Voir',
      shortlist: 'Présélectionner',
      compare: 'Comparer',
      candidateFallback: 'Candidat',
      loadingCandidateDetails: 'Chargement du détail du candidat...',
      matchScore: 'Score de correspondance : {score}',
      candidateDetailsFailed: 'Impossible de charger le détail du candidat.',
      uploadTitle: 'Importer des CV',
      supportedFiles: 'PDF et DOCX acceptés',
      limitReached: 'Limite mensuelle de CV atteinte',
      limitReachedDescription: 'Changez d’offre pour traiter plus de CV ce mois-ci.',
      dropOrBrowse: 'Déposez les CV ici ou cliquez pour parcourir',
      processing: 'Analyse en cours...',
      duplicate: 'Doublon',
      error: 'Erreur',
      done: 'Terminé',
      processWithAi: 'Analyser {count} CV avec l’IA',
      processNoCount: 'Analyser les CV avec l’IA',
      detail: {
        aiMatchScore: 'Score de correspondance IA',
        recommendation: 'Priorité de revue : {label}',
        model: 'Modèle : {label}',
        summary: 'RÉSUMÉ IA',
        whyScore: 'POURQUOI CE SCORE ?',
        scoreBreakdown: 'DÉCOMPOSITION DU SCORE',
        matchedEvidence: 'ÉLÉMENTS CORRESPONDANTS',
        matchedExcerpt: 'EXTRAIT CORRESPONDANT',
        missingEvidence: 'ÉLÉMENTS MANQUANTS',
        redFlags: 'POINTS À EXAMINER',
        cvDetails: 'DÉTAILS DU CV',
        workHistory: 'PARCOURS PROFESSIONNEL',
        strengths: 'POINTS FORTS',
        currentRole: 'Poste actuel',
        email: 'E-mail',
        phone: 'Téléphone',
        experience: 'Expérience',
        education: 'Formation',
        certifications: 'Certifications',
        cvFile: 'Fichier CV',
        lastUpdated: 'Dernière mise à jour',
        years: '{count} an{plural}',
        previousRole: 'Poste précédent',
        workHistoryAt: '{role} chez {company}',
        removeShortlist: 'Retirer de la présélection',
        addShortlist: 'Ajouter à la présélection',
        unreject: 'Réintégrer le candidat',
        reject: 'Écarter le candidat',
        removeCompare: 'Retirer de la comparaison',
        addCompare: 'Ajouter à la comparaison',
      },
    },
    comparison: {
      toasts: {
        minimum: 'Sélectionnez au moins deux candidats à comparer',
        notEnough: 'Impossible de charger assez de candidats pour comparer',
        loadFailed: 'Impossible de charger la comparaison de candidats',
        requirementsSavedRescore: 'Exigences enregistrées et scores recalculés',
        requirementsSaved: 'Exigences enregistrées',
        rescoreWarning: 'Recalcul terminé avec avertissements',
        requirementsFailed: 'Impossible de mettre à jour les exigences',
      },
      backToJob: 'Retour au poste',
      title: 'Comparaison de candidats',
      fallbackJob: 'Ce poste',
      selected: '{count} candidats sélectionnés',
      close: 'Fermer la comparaison',
      loading: 'Chargement de la comparaison...',
      unknownCandidate: 'Candidat inconnu',
      roleNotProvided: 'Poste non renseigné',
      recommendation: 'Priorité de revue : {label}',
      yearsExperience: '{count} an{plural} d’expérience',
      summary: 'RÉSUMÉ',
      scoreBreakdown: 'DÉCOMPOSITION DU SCORE',
      strengths: 'POINTS FORTS',
      matchedEvidence: 'ÉLÉMENTS CORRESPONDANTS',
      gaps: 'POINTS À EXAMINER',
      evidenceExcerpt: 'EXTRAIT JUSTIFICATIF',
      email: 'E-mail',
      phone: 'Téléphone',
      lastUpdated: 'Dernière mise à jour',
      emptyTitle: 'Aucun candidat disponible pour comparaison',
      emptyDescription: 'Retournez au détail du poste et sélectionnez au moins deux candidats.',
    },
    score: {
      overall: 'Score global',
      aiEvaluation: 'Évaluation IA',
      noAiExplanation: 'Aucune explication IA disponible.',
      redFlags: 'Points à examiner :',
      none: 'Aucun',
      mustHaveDetail: 'Détail des indispensables',
      ratio: 'ratio {value}',
      noMustHaveExplanation: 'Aucune explication des indispensables disponible.',
      hardTerms: 'Termes indispensables :',
      matched: 'Correspondants :',
      supporting: 'Éléments d’appui :',
      labels: {
        coreDomainFit: 'Adéquation au domaine',
        mustHaveMatch: 'Correspondance des indispensables',
        seniorityFit: 'Adéquation de séniorité',
        responsibilityFit: 'Adéquation responsabilités',
        toolsFit: 'Adéquation outils',
        redFlags: 'Points à examiner',
        ruleFallback: 'Score de secours',
        guardrails: 'Garde-fous',
        skillMatch: 'Correspondance des compétences',
        mustHave: 'Indispensables',
        experience: 'Expérience',
        ruleScore: 'Score par règles',
        calibration: 'Calibration',
        semanticScore: 'Score sémantique',
        coreDomain: 'Domaine principal',
        roleTitle: 'Intitulé du poste',
        responsibility: 'Responsabilités',
        seniority: 'Séniorité',
        toolPlatform: 'Outils / plateformes',
        geographyRegulatory: 'Géographie / réglementation',
        credential: 'Diplôme / certification',
        penalty: 'Pénalité',
        education: 'Formation',
        keywordMatch: 'Correspondance des mots-clés',
      },
      descriptions: {
        coreDomainFit: 'L’IA estime l’adéquation directe au domaine à {score}/100.',
        mustHaveMatch: 'L’IA estime l’adéquation aux exigences indispensables à {score}/100.',
        seniorityFit: 'L’IA estime l’adéquation de séniorité à {score}/100.',
        responsibilityFit: 'L’IA estime l’adéquation responsabilités/périmètre à {score}/100.',
        toolsFit: 'L’IA estime l’adéquation outils et plateformes à {score}/100.',
        noMajorRedFlags: 'Aucun point majeur à examiner n’a été identifié.',
        excellentSkill: 'Très bonne adéquation des compétences avec les exigences du poste',
        goodSkill: 'Bonne correspondance des compétences avec quelques écarts',
        partialSkill: 'Correspondance partielle des compétences - vérifier les écarts',
        lowSkill: 'Faible correspondance des compétences - montée en compétence possible à évaluer',
        highExperience: '{years} ans d’expérience - profil très expérimenté',
        strongExperience: '{years} ans d’expérience - parcours solide',
        developingExperience: '{years} ans d’expérience - profil en développement',
        earlyExperience: '{years} ans d’expérience - début de carrière',
        limitedExperience: 'Expérience professionnelle limitée détectée',
        degreeCerts: 'Diplôme et certifications professionnelles détectés',
        degreeOnly: 'Diplôme détecté, sans certification',
        certsOnly: 'Certifications détectées, sans diplôme',
        noEducation: 'Aucun diplôme ou certification détecté',
        closeKeyword: 'Le vocabulaire du CV est proche de la description du poste',
        goodKeyword: 'Bonne correspondance des mots-clés avec la description du poste',
        someKeyword: 'Quelques mots-clés pertinents détectés, avec une formulation différente',
        lowKeyword: 'Faible correspondance de mots-clés - le candidat utilise peut-être une autre terminologie',
        overallStrong: 'Forte correspondance - à examiner en priorité',
        overallGood: 'Bonne correspondance - candidat à examiner',
        overallModerate: 'Correspondance modérée - profil à examiner attentivement',
        overallWeak: 'Correspondance faible - écarts importants identifiés',
      },
    },
  },
}
